<template>
	<component
		:is="InterviewAiNotifications"
		:notifications="notifications"
	/>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useNotifications } from '../../store/notifications.store';

import InterviewAiNotifications from './custom-notifications.vue';

const notificationsStore = useNotifications();

const { notifications } = storeToRefs(notificationsStore);

</script>
